export const DEFAULT_REFERENCE_SOURCE = 'Annotated by curator';
